<template>
  <div :class="{ 'book-content-wrapper': true, 'book-content-wrapper_edit': !isMobile && isEditDrawerShow && currentEditHeader == 'editContent' }" :style="{ backgroundImage: `url(${bgUrl})` }">
    <transition name="fade-header" v-if="!isTraditionalPage && showBookContent">
      <div
        class="book-title fd-js-excludes"
        :style="{
          'background-color': !isMobile ? (colorSwitch === 1 ? colorContent['top-nav'] : '') : colorContent['mobile-nav'],
          color: !isMobile ? (colorSwitch === 1 ? colorContent['top-txt'] : '') : colorContent['mobile-txt']
        }"
        v-show="(isMobile && isShowTitle) || !isMobile"
        @click.stop="clickTitle"
      >
        <img :src="newLogoThumbnail" @click="goIndex" class="goIndex" v-show="isMobile" alt="logo" />
        <img :src="icons.back" @click="backBtn" class="backBtn" v-if="!isMobile && ($route.meta.requiresAuth || isGroup || isShelf) && currentEditHeader !== 'editContent'" />
        <el-tooltip popper-class="header-tooltip" effect="light" :content="shareTitle" placement="bottom">
          <div
            class="shareHeader fd-js-excludes azzzz"
            :class="{
              shareHeaderStyle: !isMobile && (isEditDrawerShow || currentEditHeader == 'editContent'),
              'ml-162': !showHeader && !isMobile,
              'ml-40': (isMobile && !showHeader && displayOrNot.login) || (isMobile && (isShelf || isGroup) && !isStaticBook),
              'ml-80': isMobile && !showHeader && displayOrNot.login && (isShelf || isGroup) && !isStaticBook
            }"
          >
            <div v-if="isMobile" class="mobile-title-wrapper" @click="titleScrolling = !titleScrolling">
              <span class="fd-js-excludes mobile-title" :class="{ 'scroll-title': titleLength >= 20 && titleScrolling }">{{ title }}</span>
            </div>
            <!--'ml-100': isMobile && !isShelf-->
            <span v-else class="fd-js-excludes">{{ title }}</span>
          </div>
        </el-tooltip>
        <div v-if="!isMobile" :class="{ search_wrapper: true, search_word_catalog: currentEditHeader == 'catalog', 'r-170': !showHeader && displayOrNot.login, 'en-US': currentLang === 1 }">
          <button @click="goArticlePage()" class="searchButton article" v-if="isPaper && displayOrNot.searchArticle === 1">
            {{ languageOptions[currentLang].searchAll }}
          </button>
          <img v-if="!isStaticBook && isShowSearchBtn && !isMobile && merge !== 1 && displayOrNot.search === 1" src="@imgs/search.png" class="pcTitleImg" @click="showSearch = !showSearch" />
          <div
            v-if="!isStaticBook && displayOrNot.search === 1 && merge !== 1"
            v-show="showSearch || !isShowSearchBtn"
            :class="{
              search_word: true,
              'search_word-fixed': isShowSearchBtn,
              'search_word-fixed-iframe': isShowSearchBtn && isIframe
            }"
          >
            <img class="icon" src="@imgs/search_word.png" alt="" />
            <input
              v-model="searchKey"
              :placeholder="languageOptions[currentLang].pleaseEnterKeywords"
              class="searchInput searchInput2"
              @keyup.enter="searchWord(1)"
              v-show="!isMobile"
              @focus="clearTip"
              @blur="showTip"
              :class="{ darkText }"
            />
            <button @click="searchWord(1)" class="searchInput-button searchButton" v-show="!isMobile">{{ languageOptions[currentLang].search }}</button>
          </div>
        </div>
        <div :style="{ position: 'absolute', right: !showHeader && displayOrNot.login && !isMobile ? (currentLang === 1 ? '200px' : '167px') : 0 }">
          <img :src="icons.mobileHelp" @click="handleShowHelps" v-if="!isMobile && displayOrNot.help" class="pcTitleImg" />
          <!--<img src="@imgs/sm_mobile.png" class="fd-js-excludes mobiletitleimg" v-else @click="ShowExplainPhone" />-->
          <button @click="digitalClick" :class="{ light: colorContent['top-icon'] === 0 }" v-if="currentEditHeader != 'catalog'" class="digital-button">数字内容编辑</button>
          <button @click="precisonClick" :class="{ light: colorContent['top-icon'] === 0 }" v-if="currentEditHeader != 'catalog'" class="precison-button">参数设置</button>
        </div>
        <div v-if="!showHeader && displayOrNot.login && !isMobile" class="pc-login">
          <div v-if="isLogin" class="book-header__login" @click="goPersonalPage">
            <img src="@imgs/toolbar/homepage-pc-top.png" alt="" />
            <span>{{ languageOptions[currentLang].myHomepage }}</span>
          </div>
          <div v-else class="book-header__login" @click="goLogin">
            <span>{{ languageOptions[currentLang].loginRegistration }}</span>
          </div>
        </div>
        <div v-if="!showHeader && displayOrNot.login && isMobile" class="book-header__login">
          <img v-if="isLogin" @click="goPersonalPage" :src="icons.homepage" alt="" />
          <img v-else @click="goLogin" :src="icons.login" alt="" />
        </div>
        <img :src="icons.libBack" @click="backBtn" class="mobileRbackBtn" v-if="isMobile && (isShelf || isGroup) && !isStaticBook" />
      </div>
    </transition>
    <div class="paper-turn__top" v-if="isTraditionalPage && showBookContent">
      <paper-page-header @togo="togo" />
    </div>
    <BookContent ref="bookContent" v-if="showBookContent"></BookContent>
    <Precision v-if="!isStaticBook" @undataBookPage="undataBookPage" ref="precision" :maxNum="parseInt(totalPage)" :setting="additionalSetting"></Precision>
    <div class="fd-nobook-container" v-if="bookPath === 'nobook'">
      <div :class="isMobile ? 'fd-nobook-mobile' : 'fd-nobook'">
        <img src="@imgs/nobook.png" />
        该书刊已被发布者删除
      </div>
    </div>
    <SearchKeys ref="searchChild" v-show="isShowSK && isShowWindow === 1" @closenow="closenow" @togo="togo"></SearchKeys>
    <Toolbar
      v-if="!isTraditionalPage"
      class="toolbar"
      ref="toolbar"
      :class="{ 'mobile-toolbar': isMobile, 'big-screen': isBigScreen, right33: isShowDigitalArticleView && currentEditHeader === 'catalog' }"
    />
  </div>
</template>

<script>
import BookContent from '@components/books/bookContent.vue'
import Precision from '@components/precisionSetting/Default.vue'
import Toolbar from '@components/toolbar/toolbar.vue'
import apis from '@api/getBook'
import login from '@api/login'
import chargeApi from '@api/chargeManager'
import statistics from '@components/books/statistics'
import wxSetting from '@components/common/wxSetting'
import SearchKeys from '@components/searchKeys'
import { isPureNum, getByteLength } from '@/utils'
import { mapState } from 'vuex'
import { getAddress, getHttpsAddress } from '@api/getBook.js'
import home from '@api/home'
import subAccount from '@api/subAccount'
import PaperPageHeader from '@components/books/PaperPageHeader'
import imgSrc from '@components/books/imgSrc'

export default {
  name: 'Book',
  data() {
    return {
      isApi: false,
      showPages: true,
      timer: null,
      isbackBtn: null,
      isShelf: false, //是否来自专辑详情
      isGroup: false, //是否来自报纸分享
      searchKey: '', //搜索关键字
      searList: [], //搜索结果数组
      posList: [], //搜索关键字位置
      isShowSK: false,
      searPage: 0,
      curKey: '',
      lockPos: false,
      darkText: true,
      searchPage: null,
      logourl: '',
      logoUrlOpen: 1,
      shareUrl: '', //书刊分享后的位置
      decryption_id: isPureNum(this.$route.query.id),
      additionalSetting: {
        dpi: '180',
        open: 0,
        pageHandle: 1,
        referer: 1,
        layoutSource: 0
      },
      showSearch: true,
      isIframe: false,
      loginUrl: window.PROJECT_CONFIG.BASE_URL,
      precisionVisible: false,
      showBookContent: false,
      viewLimit: 0,
      titleScrolling: true
    }
  },
  mixins: [statistics, wxSetting],
  computed: {
    ...mapState('book', ['isShowWindow', 'isBigScreen', 'isShowDigitalArticleView']),
    ...mapState('common', ['appSize']),
    shareTitle() {
      return this.$store.state.config.bookObj.shareTitle
    },
    title() {
      return this.$store.state.config.bookObj.title
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    isLogin() {
      return this.$store.state.common.isLogin
    },
    bookPath() {
      return this.$store.state.book.bookPath
    },
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    isShowTitle() {
      //是否显示头部
      return this.$store.state.book.isShowTitle
    },
    catalog() {
      return this.currentEditHeader == 'catalog'
    },
    bgUrl() {
      // 非自定义图片，官方模板
      let url = this.$store.state.config.bookObj.currentBgUrl
      // 这是官方模板自带图片部分
      if (url.length == 1 || url.length == 2) {
        if (parseInt(url) === 0) {
          url = 38 // 如果报纸背景=0（0是无效的），则将背景置为默认值38
        }
        this.$store.commit('config/UPDATE_CURRENT_BG', require('@imgs/bg' + url + '.png'))
        return this.$store.state.config.bookObj.currentBgUrl
      } else {
        return url
      }
    },
    newLogoThumbnail: {
      get() {
        let newLogo = this.$store.state.config.logo.newLogoThumbnail
        return newLogo ? newLogo : require('@imgs/bookshelfdetail/logo_1.png')
      },
      set(newValue) {
        this.$store.commit('config/UPDATE_NEWLOGOTHUMBNAIL', newValue)
      }
    },
    pages() {
      return this.$store.state.book.pages
    },
    currentPage() {
      let currentPageArray = this.$store.state.book.currentPage
      let page
      if (currentPageArray[0] === 0) {
        page = currentPageArray[1] + '/' + this.totalPage
      } else if (currentPageArray[1] === 0) {
        page = currentPageArray[0] + '/' + this.totalPage
      } else {
        page = currentPageArray.join(' - ') + '/' + this.totalPage
      }
      return page
    },
    currentPageNum() {
      return this.currentPage.split('/')[0]
    },
    splitCurrentPage() {
      let page
      if (this.currentPageNum.indexOf('-') > -1) {
        page = this.currentPageNum.split('-')[1]
      } else {
        page = this.currentPageNum
      }
      return page
    },
    totalPage() {
      return this.$store.state.book.totalPage
    },
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    isShowSearchBtn() {
      return this.isPaper ? this.appSize.width < 1400 : this.appSize.width < 1000
    },
    isPaper() {
      return this.$store.state.book.isPaper
    },
    showHeader() {
      return this.$route.meta.requiresAuth
    },
    userName() {
      return localStorage.getItem('username')
    },
    merge() {
      return this.$store.state.config.bookObj.merge
    },
    displayOrNot() {
      return this.$store.state.config.bookObj.displayOrNot
    },
    isTraditionalPage() {
      return this.isPaper && this.$store.state.book.bookData?.style === 1 && !this.isMobile
    },
    colorContent() {
      return this.$store.state.config.bookObj.colorContent
    },
    colorSwitch() {
      return this.$store.state.config.bookObj.colorSwitch
    },
    icons() {
      const newVar = this.isMobile ? this.colorContent['mobile-icon'] : this.colorContent['top-icon']
      const iconImage = imgSrc.iconImages[newVar]
      return iconImage
    },
    languageOptions() {
      return this.$store.state.config.languageOptions
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    },
    baozhiId() {
      return this.$store.state.config.bookObj.baozhiId
    },
    titleLength() {
      return getByteLength(this.title)
    }
  },
  methods: {
    undataBookPage() {
      this.$router.go(0)
    },
    clickTitle() {
      clearTimeout(this.timer)
    },
    ShowExplainPhone() {
      clearTimeout(this.$refs.bookContent.timer)
      this.$store.commit('book/UPDATE_IS_SHOW_PHONE_Help', true)
    },
    // 显示pc端tips操作指南
    handleShowHelps() {
      this.$store.commit('book/UPDATE_IS_SHOW_Help', true)
    },
    setPv(id) {
      if (id) {
        let sendPageViewParams = this.qs.stringify({
          id: id
        })
        const pvApi = this.isPaper ? apis.sendPaperPageView(sendPageViewParams) : apis.sendPageView(sendPageViewParams)
        pvApi.then((res) => {
          console.log('统计成功')
        })
      }
    },
    async getBookDetails(params) {
      if (this.$route.path.indexOf('paper') > -1) {
        await apis.GetPaperDetails(params).then(async (res) => {
          if (res && res.data && res.status === 200) {
            let data = res.data.data
            let viewAble = false
            //非发布状态，需要判断权限
            if (data.status !== 1) {
              if (this.isLogin) {
                //登录用户，检查“查看权限”
                //查看权限。0-仅自己可见，1-所有团队账号可见，2-指定账号可见，默认0。值为2时，viewAccount值不为空"
                viewAble = data.creator === this.userName
                if (!viewAble && data.viewPrivilege === 1) {
                  let accountRes = await subAccount.getMainChildAccountList({
                    userName: data.creator
                  })
                  if (accountRes.data.data) {
                    viewAble = accountRes.data.data.includes(this.userName)
                  }
                } else if (!viewAble && data.viewPrivilege === 2) {
                  viewAble = data.viewAccount ? data.viewAccount.includes(this.userName) : false
                }
                // 审核者若未被设置可查看未发布作品权限，
                // 在提交审核前不显示作品，
                // 提交审核后显示作品，可进行查看、审核。
                if (!viewAble) {
                  viewAble = data.status == 3 && data.auditAccount === this.userName
                }
              } else {
                // 未登录用户不可见
                this.$alert('请登录后查看', '提示', {
                  confirmButtonText: '登录',
                  showClose: false
                }).then(() => {
                  window.location.href = this.loginUrl + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
                })
                return
              }
            } else {
              viewAble = true
            }
            if (viewAble) {
              if (data.creator != this.userName) {
                // await this.getUserPageView(data.creator)
                await this.getUserNetworkFlow(data.creator)
              }
              this.setBookDetail(data)
            } else {
              this.$router.push('/none/401')
            }
          }
        })
      } else {
        // mobile 接口不验证登录信息
        apis.GetMobileBookDetails(params).then(async (res) => {
          if (res && res.data && res.status === 200) {
            let data = res.data.data
            // console.log(data, '**')
            if (data.creator != this.userName) {
              // await this.getUserPageView(data.creator)
              await this.getUserNetworkFlow(data.creator)
            }

            this.setBookDetail(data)
          }
        })
      }
    },
    setBookDetail(data) {
      // 认为书刊已被删除
      if (!data) {
        this.$store.commit('book/UPDATE_BOOK_PATH', 'nobook')
        this.showBookContent = true
        return
      }
      this.$store.commit('config/UPDATE_BUTTON', data.buttonStyle)
      this.$store.commit('config/UPDATE_LOGOURL', data.url)

      let logoImg = data.logo == 'logo.png' ? '' : data.logo
      this.$store.commit('config/UPDATE_NEWLOGOTHUMBNAIL', logoImg)
      if (data.dpi === null) {
        // DPI不存在时，则默认180
        data.dpi = 180
      }
      let currentBgImg = ''
      if (data.backgroud) {
        if (data.backgroud.length <= 2) {
          currentBgImg = 'template'
        }
        let databackgroud = data.backgroud.split('.')[0].split('/bg')[1]
        if (databackgroud && databackgroud.length <= 2) {
          currentBgImg = 'template'
        }
      } else {
        currentBgImg = 'template'
      }
      let displayOrNot = data.displayOrNot && data.displayOrNot != '' ? JSON.parse(data.displayOrNot) : {}
      let chargeIconType = data.chargeIcon && data.chargeIcon.length > 2 ? -1 : !data.chargeIcon ? 0 : parseInt(data.chargeIcon)
      let chargeIcon = data.chargeIcon
      if (data.chargeIcon && data.chargeIcon.length > 2 && data.chargeIcon.indexOf('{') > -1) {
        let option = JSON.parse(data.chargeIcon)
        chargeIconType = option.style
        chargeIcon = option.text
      }
      let colorContent =
        data.colorSwitch === 1 && data.colorContent
          ? JSON.parse(data.colorContent)
          : { 'top-nav': '#FFFFFF', 'top-txt': '#000000', 'top-icon': 1, 'mobile-nav': '#3A3A3A', 'mobile-txt': '#FFFFFF', 'mobile-icon': 0 }
      let bookData = {
        ...data,
        logoUrlOpen: data.jump != undefined ? data.jump : 1,
        buyLink: data.buyLink || '',
        currentBgUrl: data.backgroud || '38',
        currentBgImg: currentBgImg,
        chargeOn: data.charge || 1,
        catalogOn: data.openCatalog || 1,
        loadingId: data.loadEffect || 0,
        loadingColor: data.loadColor || '#df5813',
        ruleForm: {
          //需要校验项
          loadingText: data.loadText || '方正飞翔',
          price: '',
          chargePage: ''
        },
        audioData: {
          turnSound: data.openSound,
          bgSound: data.bgMusicSwitch,
          loop: data.bgMusicLoop,
          bgMusic: data.bgMusic
        },
        displayOrNot: { ...this.displayOrNot, ...displayOrNot },
        soundOn: data.openSound == 1 ? true : false,
        soundId: data.pageSound || 0,
        shareTitle: data.shareTitle || data.title || data.fileName,
        shareDesc: data.description || '',
        catalogId: data.catalog ? JSON.parse(data.catalog).catalogId : 0,
        catalogList: data.catalog ? this.processCatalogList(JSON.parse(data.catalog).catalogList, data.displayPageNo) : null,
        buyIcon: data.shoppingGuideLinkIconOption == -1 || data.shoppingGuideLinkIconOption >= 20 ? data.shoppingGuideLinkIcon : data.shoppingGuideLinkIconOption,
        buyIconType: data.shoppingGuideLinkIconOption || 1,
        chargeIconType: chargeIconType,
        chargeIcon: chargeIcon,
        questionIcon: data.questionIcon == -1 || data.questionIcon >= 20 ? data.questionnaireIcon : data.questionIcon,
        questionIconType: data.questionIcon,
        questionContent: data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(data.questionContent) : {},
        questionContentConstruction: data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(JSON.parse(data.questionContent).construction) : []
      }
      // 当问卷名称为空时，初始需要赋值为书刊名称+问卷
      if (!bookData.questionContent.formName) {
        if (bookData.shareTitle) {
          bookData.questionContent.formName = bookData.shareTitle + '问卷'
        } else if (data.shareTitle) {
          bookData.questionContent.formName = data.shareTitle + '问卷'
        } else if (data.title) {
          bookData.questionContent.formName = data.title + '问卷'
        } else if (data.fileName) {
          bookData.questionContent.formName = data.fileName + '问卷'
        } else {
          bookData.questionContent.formName = '问卷'
        }
      }
      this.$store.commit('config/UPDATE_BOOKOBJ', bookData)
      this.$store.commit('config/UPDATE_PCLOGO', bookData.pcLogo)
      this.$store.commit('config/UPDATE_DISPLAY_OR_NOT', displayOrNot)
      this.$store.commit('config/UPDATE_COLOR_CONTENT', colorContent)
      if (data.creator) {
        this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'creator', value: data.creator })
      }

      this.$store.commit('book/UPDATE_BOOK_DATA', data)
      this.$store.commit('book/UPDATE_BOOK_PATH', data.path)
      let cover = data.readModel == 1 ? data.path + '/epub/Media/cover.jpg?v=' + new Date().getTime() : data.path + '/1.jpg?v=' + new Date().getTime()
      this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'cover', value: cover })
      this.$store.commit('book/UPDATE_READ_MODEL', data.readModel)
      // UPDATE_TOTAL_PAGE
      if (!this.isApi) {
        if (data.readModel == 2) {
          this.$store.commit('book/UPDATE_TOTAL_PAGE', data.pageNumber)
          if (data.displayPageNo === 0) {
            this.$store.commit('book/UPDATE_TOTAL_PAGE', data.pageNumber)
          } else {
            if (data.displayPageNo) {
              this.$store.commit('book/UPDATE_TOTAL_PAGE', Math.min(parseInt(data.displayPageNo), data.pageNumber))
            } else {
              this.$store.commit('book/UPDATE_TOTAL_PAGE', parseInt(data.pageNumber))
            }
          }
        } else {
          if (data.displayPageNo === 0 || !data.displayPageNo) {
            this.$store.commit('book/UPDATE_TOTAL_PAGE', data.pageNumber)
          } else {
            this.$store.commit('book/UPDATE_TOTAL_PAGE', Math.min(parseInt(data.displayPageNo), data.pageNumber))
          }
        }
      } else {
        let displayPageNo = this.$store.state.config.bookObj.displayPageNo // 是否展示音乐图标
        if (displayPageNo >= data.pageNumber) {
          displayPageNo = 0
          this.$store.commit('book/UPDATE_TOTAL_PAGE', data.pageNumber)
        } else {
          this.$store.commit('book/UPDATE_TOTAL_PAGE', displayPageNo)
        }
      }
      this.$store.commit('book/SHOW_UPDATE_TOTAL_PAGE', data.pageNumber)
      this.$store.commit('book/UPDATE_PLAY', data.openSound == 1)
      this.showHelp()
      if (!data.openSound) {
        this.$store.commit('book/UPDATE_PLAY', false)
      }

      this.$setDocumentTitle(data.shareTitle || data.title || data.fileName)
      this.setPv(data.id)

      if (this.isMobile && this.$store.state.config.bookObj.navbarSwtich === 0) {
        this.timer = setTimeout(() => {
          this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
          this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
        }, 5000)
        this.$store.commit('book/UPDATE_TIMER', this.timer)
      } else if (this.$store.state.config.bookObj.navbarSwtich === 1) {
        this.$store.commit('book/UPDATE_IS_LOCK', true)
        this.$store.commit('book/UPDATE_IS_SHOW_TITLE', true)
        this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', true)
      }

      // 参数设置：初始数值
      this.additionalSetting = {
        referer: data.referer,
        dpi: String(data.dpi) || '180',
        open: data.open || 0,
        pageHandle: 0,
        displayPageNo: data.displayPageNo,
        layoutSource: data.layoutSource
      }

      this.logourl = data.url
      this.logoUrlOpen = data.jump != undefined ? data.jump : 1
      this.showBookContent = true
    },
    // 书刊部分展示时，删除冗余页码目录
    processCatalogList(catalog, displayPageNo) {
      if (displayPageNo === 0 || !catalog) {
        return catalog
      }

      function deleteNode(arr) {
        let list = arr
        for (let i = 0; i < list.length; ) {
          if (list[i].page > displayPageNo) {
            list.splice(i, 1)
          } else if (list[i].children && list[i].children.length > 0) {
            deleteNode(list[i].children)
            i++
          } else {
            i++
          }
        }
      }

      deleteNode(catalog)
      return catalog
    },
    // 获取书签
    getBookmarkList() {
      apis.findBookMarkList(this.decryption_id).then((res) => {
        if (res?.data.status === 0) {
          this.$store.commit('book/UPDATE_BOOKMARK_LIST', res.data.data || [])
        }
      })
    },
    digitalClick() {
      console.log(this.$route, this.isPaper)
      this.$router.push({
        path: '/digital',
        query: {
          id: this.$route.query.id,
          isPaper: this.isPaper,
          type: this.isPaper ? 'paper' : 'book'
        }
      })
    },
    //弹出精度设置框
    precisonClick() {
      this.$refs.precision.dialogVisible = true
      $('.menu-list').hide()
    },
    backBtn() {
      // 返回列表，需要区分专辑和书刊列表分享
      if (this.$route.query.form && this.$route.query.shelfId && this.$route.query.libId) {
        let shelfId = this.$route.query.shelfId
        let libId = this.$route.query.libId
        let openMode = this.$route.query.openMode
        let urls = `/bookshelfdetail?id=${shelfId}&forms=booklibdetail&libId=${libId}&openMode=${openMode}`
        if (this.$route.query.linkReturn) {
          // urls = `/bookshelfdetail?id=${shelfId}&forms=booklibdetail&libId=${libId}&openMode=${openMode}&linkReturn=${this.$route.query.linkReturn}`
          window.history.back()
          setTimeout(() => {
            window.location.reload()
          }, 50)
        } else {
          this.$router.replace(urls)
        }
      } else if (this.$route.query.form && this.$route.query.shelfId) {
        let shelfId = this.$route.query.shelfId
        let openMode = this.$route.query.openMode

        let urls = `/bookshelfdetail?id=${shelfId}&openMode=${openMode}`
        if (this.$route.query.linkReturn) {
          // urls = `/bookshelfdetail?id=${shelfId}&openMode=${openMode}&linkReturn=${this.$route.query.linkReturn}`
          window.history.back()
          setTimeout(() => {
            window.location.reload()
          }, 50)
        } else {
          this.$router.replace(urls)
        }
      } else if ((this.$route.query.form || this.$route.query.forms) && this.$route.query.libId) {
        let id = this.$route.query.libId
        let openMode = this.$route.query.openMode
        let urls = `/bookLibdetail?id=${id}&openMode=${openMode}`
        if (this.$route.query.linkReturn) {
          // urls = `/bookLibdetail?id=${id}&openMode=${openMode}&linkReturn=${this.$route.query.linkReturn}`
          window.history.back()
          setTimeout(() => {
            window.location.reload()
          }, 50)
        } else {
          this.$router.replace(urls)
        }
      } else if (this.isGroup) {
        let userName = this.$store.state.config.bookObj.creator
        localStorage.removeItem('from')
        sessionStorage.removeItem('userName')
        this.$router.push({ path: '/paperSharePage', query: { user: userName } })
      } else if (this.$route.path.indexOf('paper') > -1) {
        this.$router.replace('/list?to=paper')
      } else {
        this.$router.replace('/list?to=book')
      }
    },
    goIndex() {
      if (this.logoUrlOpen === 0) {
        return
      }
      if (this.logourl) {
        window.location.href = this.logourl
      } else {
        window.location.href = `${window.PROJECT_CONFIG.BASE_URL}/elecPublish/`
      }
    },
    /*setStatisticsData(type, lock) {
      var wcsrc
      if (type === 'view' && lock) {
        wcsrc = lock
      } else {
        wcsrc = ''
      }
      console.log('统计日志，类型' + type + 'wcsrc: ' + wcsrc)
      var browser = this.getBrowser()
      var openType = this.getOpenType()
      var system = this.getSystem()
      console.log('book address', this.address)
      var data = {
        it: this.isPaper ? 'epaper' : 'ebook',
        ii: this.decryption_id,
        uid: '',
        un: this.userName || '',
        br: browser,
        ar: this.address,
        cl: openType,
        be: type,
        os: system,
        dur: '', //阅读时长
        cr: '', //作者
        wcsrc: wcsrc //微信打开来源
      }
      var url = window.PROJECT_CONFIG.BASE_URL2 + '/stat/log'
      $.ajax({
        url: url,
        type: 'GET',
        data: data,
        contentType: 'application/json',
        dataType: 'json',
        success: function(data) {},
        error: function(msg) {}
      })
    },
    //判断url里面是否有?
    //获取查询字符串信息 url上的作品id和param
    getSearchString(key) {
      // 获取URL中?之后的字符
      var str = window.location.href

      // 以&分隔字符串，获得类似id=123这样的元素数组
      var arr = str.split('&')
      var obj = new Object()

      // 将每一个数组元素以=分隔并赋给obj对象
      for (var i = 0; i < arr.length; i++) {
        var tmp_arr = arr[i].split('=')
        obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1])
      }
      return obj[key]
    },*/
    // 搜索书刊文字
    searchWord(page) {
      if (this.darkText && this.searchKey === '请输入关键字') {
        this.searchKey = ''
      }
      this.$refs.searchChild.search(page, this.searchKey)
      this.showTip()
    },
    goArticlePage() {
      this.$router.push({
        path: 'paperArticleShare',
        query: { user: this.$store.state.config.bookObj.creator }
      })
    },
    clearTip() {
      if (this.darkText && this.searchKey == '请输入关键字') {
        this.searchKey = ''
        this.darkText = false
      }
    },
    showTip() {
      if (this.searchKey == '') {
        this.searchKey = ''
        this.darkText = true
      }
    },
    closenow(payload) {
      this.isShowSK = payload
    },
    showHelp() {
      // 是否显示提示
      if (this.isMobile) {
        // 移动端
        if (localStorage.getItem('helpsIsMobile')) {
          this.$store.commit('book/UPDATE_IS_SHOW_PHONE_Help', false)
          clearTimeout(this.timer)
        } else {
          localStorage.setItem('helpsIsMobile', 'setIsMobile')
          this.$store.commit('book/UPDATE_IS_SHOW_PHONE_Help', true)
          this.timer = setTimeout(() => {
            this.$store.commit('book/UPDATE_IS_SHOW_PHONE_Help', false)
          }, 5000)
        }
      } else {
        // pc端
        if (localStorage.getItem('helps')) {
          this.$store.commit('book/UPDATE_IS_SHOW_Help', false)
        } else {
          localStorage.setItem('helps', 'setName')
          this.$store.commit('book/UPDATE_IS_SHOW_Help', true)
        }
      }
    },
    togo(item) {
      this.$emit('togo', item)
      if (item.edition && item.id && item.lineText && item.pageIndex && item.title && item.xuHao) {
        // readmodel=2读取文章
        this.$refs.bookContent.getXiaoYangDetailInfo(item.id)
        this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', !this.isEditDrawerShow)
        this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
        if (this.isTraditionalPage) {
          this.$store.commit('book/UPDATE_CURRENT_PAGE', [Math.max(item.pageIndex, 0)])
        }
      }
    },
    goLogin() {
      window.location.href = this.loginUrl + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
    },
    goPersonalPage() {
      this.$router.push({ path: '/personal' })
    },
    async getGoodsInfo() {
      await chargeApi.queryOneBookReadable({ ebookId: this.decryption_id, albumId: this.$route.query.shelfId }).then(async (res) => {
        if (res.data) {
          if (res.data.status === 0) {
            this.$store.commit('common/UPDATE_IS_ORDERED', true)
          } else {
            let param
            if (res.data.data && res.data.data.length > 0) {
              this.$store.commit('common/UPDATE_GOODS_OBJ_LIST', res.data.data)
              param = {
                worksId: res.data.data[0].worksId,
                worksType: res.data.data[0].worksType
              }
              this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksType', value: res.data.data[0].worksType })
              this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksId', value: res.data.data[0].worksId })
            } else {
              param = {
                worksId: this.decryption_id,
                worksType: 'cloud_read_ebook'
              }
              this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksId', value: this.decryption_id })
              this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksType', value: 'cloud_read_ebook' })
            }
            if (!this.$store.state.config.bookObj.charge) {
              this.$store.commit('config/CHARGE', { type: 'bookObj', value: 1 })
            }
            await chargeApi.getGoodsInfo(param).then((res) => {
              let data = res.data.data
              if (data) {
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'chargePage', value: data.trialOption === 1 ? this.totalPage : data.chargePage || 0 })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'creator', value: data.creator })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'price', value: data.price })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksName', value: data.worksName })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'secret', value: data.secret })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'articlePrice', value: data.articlePrice })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'trialPercent', value: data.trialPercent })
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'trialOption', value: data.trialOption })
                if (data.secret === 1) {
                  this.$store.commit('config/CHARGE', { type: 'bookObj', value: 2 })
                }
              }
            })
          }
        }
      })
      if (this.$route.query.chargePage) {
        this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'chargePage', value: this.$route.query.chargePage })
      }
    },
    getBaozhiGoods() {
      this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksId', value: this.baozhiId })
      this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksType', value: 'cloud_read_epaper' })
      chargeApi.getGoodsInfo({ worksId: this.baozhiId, worksType: 'cloud_read_baozhi' }).then((res) => {
        let data = res.data.data
        if (data) {
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'secret', value: data.secret })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
          this.$store.commit('common/UPDATE_GOODS_OBJ', {
            type: 'chargePage',
            value: data.trialOption === 1 ? this.totalPage : data.chargePage || 0
          })
          if (data.secret === 1 && this.userName != data.creator) {
            // this.$store.commit('config/CHARGE', { type: 'bookObj', value: 1 })
            home.findOneSubscribe({ worksId: this.decryption_id, worksType: 'cloud_read_baozhi' }).then((res) => {
              if (res.data.status === 0) {
                this.$store.commit('common/UPDATE_IS_ORDERED', true)
              } else {
                if (!this.isLogin) {
                  this.$message('需登录后查看')
                  this.showBookContent = false
                  this.goLogin()
                } else {
                  this.showBookContent = false
                  this.$alert('抱歉您没有权限继续阅读此作品。', { title: '提示', customClass: this.isMobile ? 'secret-message-box_mobile' : '', showClose: false, showConfirmButton: false })
                }
              }
            })
          }
        }
      })
    },
    getUserPageView(creator) {
      const params = {
        userName: creator
      }
      home.getUserPageView(params).then((res) => {
        let { status, data } = res.data
        if (status === 0) {
          this.viewLimit = data.limit - data.used
        } else {
          this.viewLimit = -1
        }
      })
    },
    getUserNetworkFlow(creator) {
      // 作者不限制
      const params = {
        userName: creator
      }
      home.getUserNetworkFlow(params).then((res) => {
        let { status, data } = res.data
        if (status === 0) {
          let limit = data.limit
          let used = (data.used / (1024 * 1024 * 1024)).toFixed(2)
          this.$emit('get-exceed', (limit - used).toFixed(2) < 0)
        }
      })
    }
  },
  components: {
    PaperPageHeader,
    BookContent,
    Precision,
    SearchKeys,
    Toolbar
  },
  async created() {
    if (this.$route.path.indexOf('paper') > -1) {
      this.$store.commit('book/UPDATE_IS_PAPER', true)
      //TODO 数字报需要付费时要删除该代码
      this.$store.commit('config/CHARGE', { type: 'bookObj', value: 0 })
    } else {
      this.$store.commit('book/UPDATE_IS_PAPER', false)
    }
    if (!this.isStaticBook) {
      //检测登陆状态
      await login.login().then((res) => {
        if (res && res.data && res.status === 200) {
          let data = res.data
          if (data.code === 101) {
            this.$store.commit('common/UPDATE_IS_LOGIN', false)
          } else if (data.data.username) {
            localStorage.setItem('username', data.data.username)
            this.$store.commit('common/UPDATE_IS_LOGIN', true)
          }
        }
      })
    }
    var IS_TRUE = window.localStorage.getItem('IS_TRUE')
    if (IS_TRUE == 1) {
      this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'editContent')
      window.localStorage.setItem('IS_TRUE', 0)
    }

    this.$store.commit('book/UPDATE_BOOK_PATH', '')

    // 如果是打静态包，初始化必要数据
    if (this.isStaticBook) {
      this.$nextTick(() => {
        const totalPage = window.staticOptions.totalPage
        const title = window.staticOptions.title
        this.$store.commit('book/UPDATE_TOTAL_PAGE', totalPage)
        this.$store.commit('config/UPDATE_TITLE_MESSAGE', title)
        if (totalPage) {
          const bookPath = './source/'
          this.$store.commit('book/UPDATE_BOOK_PATH', bookPath)
          this.$store.commit('config/UPDATE_CURRENT_BG', window.staticOptions.currentBgUrl)
        } else {
          this.$store.commit('book/UPDATE_BOOK_PATH', 'nobook')
        }
      })
      return
    }
    this.getIpLocation()
    this.$store.commit('book/UPDATE_TIMER', null)
    this.$store.commit('book/UPDATE_IS_LOCK', false)

    // 判断是否从专辑或者图书馆来
    if ((this.$route.query.form || this.$route.query.forms) && (this.$route.query.shelfId || this.$route.query.libId)) {
      let isShowCommerHeader = false
      this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', isShowCommerHeader)
      this.isShelf = true
      this.$store.commit('config/UPDATE_FROMALBUM', true)
    }
    // 判断是否从报纸分享页来
    const from = this.$route.query.from
    if (from == 'paperGroup') {
      this.isGroup = true
    }
  },
  async mounted() {
    if (self !== top) {
      this.isIframe = true
    }
    const displayPageNo = this.$store.state.config.bookObj.displayPageNo

    if (displayPageNo !== 0) {
      this.$store.commit('book/UPDATE_TOTAL_PAGE', displayPageNo)
      this.isApi = true
    }
    if (this.isMobile) {
      // 移动端微信浏览器拖动书刊区域时禁止下拉
      document.querySelector('.book-content-wrapper').addEventListener(
        'touchmove',
        function(e) {
          e.preventDefault()
        },
        { passive: false }
      )
    }

    //静态包不发送请求
    if (this.isStaticBook) {
      return
    }

    // 请求书刊详情
    const params = {
      id: this.decryption_id
    }
    // await this.getUserPageView()
    await this.getBookDetails(params)
    if (!this.isPaper) {
      await this.getGoodsInfo()
    } else {
      await this.getBaozhiGoods()
    }

    this.$nextTick(() => {
      if (this.$store.state.config.bookObj.charge !== 0) {
        if (this.$store.state.common.goodsObj.chargePage < 1 && !this.isLogin) {
          this.goLogin()
        }
        if (this.$store.state.common.goodsObj.chargePage < 1 && this.isLogin) {
          this.$refs.toolbar.showOrder()
        }
      }
    })

    if (!this.isPaper) {
      await this.getBookmarkList()
    }

    // 初始化微信设置
    this.shareUrl = window.location.href.split('#')[0]
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      const wxParams = {
        id: this.decryption_id,
        currentUrl: this.shareUrl
      }
      if (this.isPaper) {
        let sharePaperUrl = window.location.origin + '/ebook/epaper/index.jhtml?' + window.location.href.split('?')[1]
        this.getWXConfig(wxParams, apis.getPaperWXConfig, true, null, sharePaperUrl)
      } else {
        this.getWXConfig(wxParams, apis.getWXConfig, false)
      }
    } else {
      console.log('不是微信浏览器')
    }

    if ($('#app').width() < 1000) {
      this.showSearch = false
    }
    setTimeout(() => {
      let appDiv = $('#app')
      let appSize = { height: parseInt(appDiv.height()), width: parseInt(appDiv.width()) }
      this.$store.commit('common/UPDATE_APP_SIZE', appSize)
      if ($('.common-header').length < 1) {
        this.isIframe = true
      }
    }, 1000)
  },
  destroyed() {
    localStorage.removeItem('from')
    sessionStorage.removeItem('userName')
    let isShowCommerHeader = true
    this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', isShowCommerHeader)
    this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', false)
    this.$store.commit('common/UPDATE_GOODS_OBJ_LIST', [])
    this.$store.commit('config/UPDATE_DISPLAY_OR_NOT', { login: 1, collect: 1, thumbnail: 1, catalog: 1, search: 1, share: 1, help: 1, searchArticle: 1 })
    this.$store.commit('config/UPDATE_COLOR_CONTENT', { 'top-nav': '#FFFFFF', 'top-txt': '#000000', 'top-icon': 1, 'mobile-nav': '#3A3A3A', 'mobile-txt': '#FFFFFF', 'mobile-icon': 0 })
    this.$store.commit('config/UPDATE_COLOR_SWITCH', 0)
    this.$store.commit('common/UPDATE_GOODS_OBJS', {
      period: 0,
      creator: '',
      chargeBook: '',
      worksName: '',
      chargePage: 0,
      worksId: '',
      price: '',
      cover: '',
      worksType: '',
      secret: 0,
      trialPercent: 0,
      trialOption: 0,
      articlePrice: ''
    })
  }
}
</script>

<style lang="scss">
.paper-turn__top {
  background-color: #fff;
}
.header-tooltip {
  max-width: 80vw;
  text-align: center;
}
.toolbar {
  position: fixed;
  bottom: 60px;
  right: 20px;
  &.right33 {
    right: calc(33% + 10px);
  }
  &.mobile-toolbar {
    right: 10px;
    // 40 + 10
    bottom: 70px;
    &.big-screen {
      // 56 + 10
      bottom: 66px;
    }
  }
}
.mobile .book-content-wrapper {
  display: block;
}
.book-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: cover;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &_edit {
    width: calc(100% - 300px);
    margin-left: 300px;
  }
  .fd-nobook-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .fd-nobook {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 400px;
      height: 267px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      color: #fff;
      img {
        margin-bottom: 20px;
      }
    }
    .fd-nobook-mobile {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 60vw;
      height: 45vw;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      color: #fff;
      font-size: 16px;
      img {
        width: 56px;
        height: 52px;
        margin-bottom: 20px;
      }
    }
  }
  .book-title {
    background-color: #ffffff;
    // opacity: 0.5;
    height: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    color: #000000;
    line-height: 40px;
    z-index: 2;
    font-size: 16px;
    button {
      font-size: 14px;
      cursor: pointer;
    }
    .shareHeader {
      flex: 1;
      height: 40px;
      line-height: 40px;
      text-align: center;
      display: inline-block;
      .mobile-title-wrapper {
        display: inline-block;
        white-space: nowrap;
        width: 40vw;
        overflow-x: hidden;
      }
      .mobile-title {
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        font-size: 16px;
        width: 100%;
        text-overflow: ellipsis;
      }
      .scroll-title {
        width: fit-content !important;
        position: relative; /* 使内部元素的定位相对于容器 */
        animation: scrollText 7s linear infinite; /* 应用动画 */
      }
      @keyframes scrollText {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-60%);
        }
      }
    }
    .ml-40 {
      margin-left: 40px;
    }
    .ml-80 {
      margin-left: 80px;
      width: 65px;
    }
    .shareHeaderStyle {
      width: calc(100% - 260px);
    }
    .digital-button {
      width: 120px;
      margin-right: 7px;
    }
    .precison-button {
      margin-right: 7px;
    }
    .search_wrapper {
      display: flex;
      position: absolute;
      right: 257px;
      z-index: 999;
      .searchInput {
        height: 30px;
        margin-top: 0;
        border: none;
        font-size: 14px !important;
        // background: url('../assets/imgs/search_word.png') no-repeat;
      }
      .darkText {
        color: rgb(117, 117, 117);
      }
      .search_word {
        display: flex;
        align-items: center;
        padding-top: 5px;
      }
      .searchInput2 {
        padding-left: 30px;
        width: 280px;
        border-radius: 15px;
        padding-right: 60px;
        border: 1px solid rgba(58, 58, 58, 0.5);
      }
      .searchButton {
        border: none;
        background: #df5813;
        color: #fff;
        cursor: pointer;
        &.article {
          margin-right: 30px;
        }
      }
      .searchInput-button {
        border-radius: 15px;
        height: 24px;
        margin-top: 0;
        width: 55px;
        margin-left: -60px;
      }
      img.icon {
        height: 20px;
        margin-right: -25px;
        z-index: 2;
      }
      .pcTitleImg {
        margin-left: 0;
      }
      .tip {
        position: absolute;
        color: rgb(117, 117, 117);
        font-size: 14px;
        left: 25px;
        height: 40px;
        line-height: 40px;
        // top: 10px;
      }
    }
    .search_word_catalog {
      right: 45px;
    }
    .r-170 {
      right: 220px;
      &.en-US {
        right: 250px;
      }
    }
    .search_word_nocatalog_nopaper {
      right: 130px;
    }
    .search_word {
      position: relative;
    }
    .search_word-fixed {
      position: fixed;
      right: 10px;
      top: 125px;
    }
    .search_word-fixed-iframe {
      top: 45px;
    }
    .backBtn {
      width: 25px;
      height: 25px;
      position: absolute;
      left: 0;
      cursor: pointer;
      margin: 7.4px 7.4px 7.4px 10px;
    }
    .pcTitleImg {
      width: 25px;
      height: 25px;
      cursor: pointer;
      margin: 7.4px 10px -7.4px 7.4px;
    }
    .mobiletitleimg {
      width: 26px;
      height: 26px;
      margin-right: 10px;
      cursor: pointer;
    }
    button {
      width: 80px;
      height: 30px;
      text-align: center;
      outline: none;
      border: 1px solid #000;
      background: none;
      color: #000000;
      margin-top: 5px;
      &.light {
        color: #ffffff;
        border-color: #ffffff;
      }
    }
  }
  .book-content {
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .book-header__login {
    display: inline-flex;
    align-items: center;
    padding: 5px 15px;
    margin-top: 5px;
    height: 30px;
    cursor: pointer;
    position: absolute;
    right: 40px;
    min-width: 115px;
    justify-content: center;
    img {
      margin-right: 5px;
      transform: translateY(0) !important;
      width: 24px;
    }
  }
  .pc-login {
    .book-header__login {
      background-color: #df5813;
      border-radius: 15px;
      color: #ffffff !important;
      font-size: 14px;
    }
  }
}
.mobile {
  .book-content {
    height: 100%;
  }
  .book-content-wrapper {
    .book-title {
      // position: relative;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: #3a3a3a;
      // opacity: 1;
      .search_word {
        display: none;
      }
      img {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 26px;
        height: 27px;
      }
      .backBtn {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 26px;
        margin-top: 0;
      }
      .goIndex {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        // width: 50px;
        width: auto;
        height: 20px;
        margin-top: 0;
        margin-left: 10px;
      }
      .mobileRbackBtn {
        position: relative;
        transform: translateY(-50%);
        width: 26px;
        height: 27px;
        margin-right: 10px;
      }
      button {
        font-size: 14px;
      }
      .book-header__login {
        border: none;
        padding: 0;
        margin-right: 0;
        display: inline;
        height: 100%;
        vertical-align: middle;
        margin-top: 0;
        position: unset;
        min-width: 30px;
        img {
          position: unset;
          vertical-align: middle;
        }
      }
    }
  }
}
.restricted-container {
  position: fixed;
  z-index: 9999;

  color: #df5813;
  font-size: 25px;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  &__content {
    position: relative;
    left: 50%;
    top: 50%;
    margin-left: -200px;
    margin-top: -230px;
    width: 400px;
    height: 300px;
    border-radius: 4px;
    background-color: #fff;
    text-align: center;
    line-height: 300px;
  }
}
.t-120 {
  top: 120px;
}
.restricted-m {
  //left: 50%;
  //top: -50%;
  margin-left: -140px;
  margin-top: -120px;
  width: 280px;
  height: 240px;
  line-height: 240px;
  color: #000;
}

@media screen and (orientation: landscape) {
  /*横屏 css*/
  .mobile .book-content-wrapper {
    padding: 45px 0;
  }
  .mobile .book-content {
    padding: 0;
  }
}
.fd-mobile .fade-header-enter-active {
  transition: all 0.5s;
}
.fd-mobile .fade-header-leave-active {
  transition: all 0.5s;
}
.fd-mobile .fade-header-enter,
.fd-mobile .fade-header-leave-to {
  transform: translateY(-40px);
  opacity: 0;
}
</style>
